import AmexResyCreditNAA from './AmexResyCreditNAA';

export default AmexResyCreditNAA;
